import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	createPromocodeRegistryQuery,
	Promocode,
	PromocodeRegistryFilters,
	PromocodeRegistryQuery,
} from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel, SORT_DIRECTIONS } from 'shared/lib';

type CreatePromocodeRegistryModelParams = {
	$voucherId: Store<number | null>;
	query?: PromocodeRegistryQuery;
} & RegistryCallbacks;

export type PromocodeRegistryModel = RegistryModel<
	Promocode,
	PromocodeRegistryFilters,
	JsonApiRequestError
>;

export const createPromocodeRegistryModel = ({
	$voucherId,
	query: queryOverride,
	...params
}: CreatePromocodeRegistryModelParams): PromocodeRegistryModel => {
	const query = queryOverride ?? createPromocodeRegistryQuery($voucherId);

	const model = createRegistryModel({
		query,
		filters: {
			statuses: [],
		},
		sortField: 'code',
		sortDirection: SORT_DIRECTIONS.ASC,
		...params,
	});

	return model;
};
